module.exports = __webpack_public_path__ + "img/wxfriend.dfd21b18.png";